"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactType = exports.IntermediateRecordConfigSchema = exports.nodeType = exports.UIConfigSchema = void 0;
const finley_types_1 = require("@finley-technologies/finley-types");
const v4_1 = require("zod/v4");
const sampling = finley_types_1.AssetVerification.SamplingSchema.optional().describe('If undefined, defaults to SampleAll');
exports.UIConfigSchema = v4_1.z.object({
    artifactSlug: v4_1.z.string().describe('Artifact slug'),
    description: v4_1.z.string().describe('Description'),
    loanProductSlug: v4_1.z
        .string()
        .describe('Identifies loan product that will be evaluated.'),
    creditFacilitySlug: v4_1.z
        .string()
        .describe('Identifies credit facility for which loan product will be evaluated'),
    assetVerificationConfig: finley_types_1.AssetVerification.AssetConfigSchema.describe('Asset verification config decides how should the loanTape be validated against the asset.'),
    sampling,
});
exports.nodeType = 'file_generatedReceivableInvoice';
exports.IntermediateRecordConfigSchema = exports.UIConfigSchema.omit({
    artifactSlug: true,
    loanProductSlug: true,
    creditFacilitySlug: true,
});
exports.artifactType = 'receivableInvoice';
//# sourceMappingURL=types.js.map